import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import NoProductFound from './NoProductFound';
import '../../Assets/CSS/Product.css'

const List = ({ results, params, isLoading }) => {
    return (
        <div>
            <div className='d-flex'>
                <h5 className='fs-5 fw-normal'>Search Result</h5>
                <span className='ps-2'>(Showing {isLoading ? '...' : results.length} Products)</span>
            </div>
            <Row className="mt-2 g-4">
                {isLoading ? (
                    Array.from({ length: 6 }).map((_, index) => (
                        <Col md={3} sm={6} xs={12} key={index} className='d-flex'>
                            <Card className="shadow p-2 h-100 d-flex flex-column w-100">
                                <Skeleton height={200} className='rounded-3' />
                                <Card.Body className="d-flex pt-3 flex-column justify-content-between">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={15} width={120} className='my-2' />
                                    <Skeleton height={12} width={180} />

                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                ) : results.length > 0 ? (
                    results.map((product) => (
                        <Col md={3} sm={6} xs={12} key={product.productId} className='d-flex'>
                            <Link
                                to={`/productdetail/${product.productId}`}
                                className="text-decoration-none text-dark w-100"
                            >
                                <Card className="product-card p-2 h-100 d-flex flex-column">
                                    <Card.Img
                                        variant="top"
                                        src={
                                            product.productImageUrls && product.productImageUrls.length > 0
                                                ? product.productImageUrls[0]
                                                : "https://via.placeholder.com/200"
                                        }
                                        className='img-fluid rounded-3'
                                        style={{ height: '200px', objectFit: 'cover' }}
                                    />
                                    <Card.Body className="d-flex pt-3 flex-column justify-content-between">
                                        <Card.Title
                                            style={{ color: '#303030', fontSize: '16px', fontWeight: '500' }}
                                        >
                                            {product.productName || 'Unknown Product'}
                                        </Card.Title>
                                        <Card.Subtitle
                                            className="my-2"
                                            style={{ color: '#606060', fontSize: '14px', fontWeight: '400' }}
                                        >
                                            {product.productCategoryNames || 'Unknown Category'}
                                        </Card.Subtitle>
                                        <Card.Text
                                            style={{ color: '#A0A0A0', fontSize: '12px', fontWeight: '400' }}
                                        >
                                            Manufacturer: {product.sellerName || 'Unknown'}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    ))
                ) : (
                    <NoProductFound />
                )}
            </Row>
        </div>
    );
};

export default List;
